import { render, staticRenderFns } from "./MainClaimPage.vue?vue&type=template&id=ea0cd2b8&scoped=true&"
import script from "./MainClaimPage.vue?vue&type=script&lang=js&"
export * from "./MainClaimPage.vue?vue&type=script&lang=js&"
import style0 from "./MainClaimPage.vue?vue&type=style&index=0&id=ea0cd2b8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea0cd2b8",
  null
  
)

export default component.exports